import React from 'react';
import './App.scss';
import {Amplify} from 'aws-amplify';
import amplifyconfiguration from '../amplifyconfiguration.json';
import aws_exports_custom from '../aws-exports-custom';
import api_config from '../api/aws-config';
import Impress from './Impress/Impress';
import '../eeTheme.scss';

const newAwsCloudLogicCustom = amplifyconfiguration.aws_cloud_logic_custom.concat(aws_exports_custom.aws_cloud_logic_custom);
amplifyconfiguration.aws_cloud_logic_custom = newAwsCloudLogicCustom;
Amplify.configure({...amplifyconfiguration, ...api_config});


const App = () => {
    return (
        <div className={"App"}>
            <Impress />
        </div>
    );
}

export default App;
